export { StatusSwitch } from './StatusSwitch';
export const STATUS = Object.freeze({
  NO_STATUS: 'no-status',
  DONE: 'done',
  LOADING: 'loading',
  ERROR: 'error',
});
